export default {
    finance: {
        loanPrograms: {
            title: "Loan Programs",
            create: "Create Loan Program",
            edit: "Edit Loan Program",
            details: "Program Details",
            programTitle: "Program Title",
            programLogo: "Program Logo",
            applicationForm: "Application Form",
            viewApplications: "View Applications",
            cooperative: "Cooperative",
            bank: "Bank",
            status: "Status",
            allStatuses: "All Statuses",
            active: "Active",
            inactive: "Inactive",
            approvalFlowSetting: "Approval Flow Setting",
            concludeBeforeBank: "Conclude a loan application before sending to the bank.",
            allowBankRequestInfo: "Allow the Bank to request for more information from the applicant.",
            currency: "Currency",
            loanAmountMin: "Loan amount - Minimum",
            loanAmountMax: "Loan amount - Maximum",
            term: "Term",
            yield: "Yield",
            typeOfFinancing: "Type of financing",
            gracePeriod: "Grace period",
            country: "Country",
            regions: "Regions",
            crops: "Crops",
            dataFields: "Data Fields",
            dataFieldsConfigured: "Data fields configured for this loan program",
            signature: "Signature",
            viewSignatureFile: "View signature / file",
            description: "Description",
            conditionsRequirements: "Conditions & Requirements",
            digitalSignature: "Digital signature",
            fileUpload: "File upload",
            failedLoadLoanProgramDetails: "Failed to load loan program details",
            failedLoadLoanProgram: "Failed to load loan program",
            failedLoadApplicationForm: "Failed to load application form",
            loanProgramUpdatedSuccess: "Loan program updated successfully",
            loanProgramCreatedSuccess: "Loan program created successfully",
            applicationFormUpdatedSuccess: "Application form updated successfully",
            failedUpdateLoanProgram: "Failed to update loan program",
            failedCreateLoanProgram: "Failed to create loan program",
            failedUpdateApplicationForm: "Failed to update application form",
            fillRequiredFields: "Please fill in all required fields",
            fileUploadRequiredFor: "A file upload is required for",
            selectAtLeastOneOptionFor: "Select at least one option for",
            fieldRequired: "This field is required",
            chooseValidOptionFor: "Choose a valid option for",
            enterValidAmountFor: "Enter a valid amount for",
            selectValidUnitFor: "Select a valid unit for",
            step1ProgramDetails: "Step 1: Program Details",
            step2ApplicationForm: "Step 2: Application Form",
            months: "months",
            years: "years",
            days: "days",
            weeks: "weeks",
            previewForm: "PREVIEW FORM",
            backUpper: "BACK",
            basicInformation: "Basic Information",
            basicInformationHint: "Enter the basic information for the loan program.",
            enterProgramTitle: "Enter program title",
            attachProgramLogo: "Attach Program Logo",
            selectProgramLogoImage: "Select program logo image",
            selectFileUploadProgramLogo: "Select file to upload program logo",
            orDragDrop: "or drag and drop here",
            removeFile: "Remove file",
            loanProgramSettings: "Loan Program Settings",
            loanProgramSettingsHint: "Enter the loan program settings for the loan program.",
            selectBank: "Select bank",
            applicationApproval: "Application Approval",
            applicationProcess: "Application Process",
            loanDetails: "Loan Details",
            loanDetailsHint: "Enter the loan details for the loan program.",
            selectCurrency: "Select currency",
            enterMinLoanAmount: "Enter minimum loan amount",
            enterMaxLoanAmount: "Enter maximum loan amount",
            enterHere: "Enter here",
            interestRate: "Interest Rate",
            yieldPerYear: "Yield - per year",
            enterYieldPerYear: "Enter yield per year",
            selectTypeOfFinancing: "Select type of financing",
            gracePeriodMax: "Grace Period - Maximum",
            selectCrops: "Select crops",
            selectCountry: "Select country",
            selectRegions: "Select regions",
            addNewDataField: "ADD NEW DATA FIELD",
            enterProgramDescription: "Enter program description",
            programApplicationForm: "Program Application Form",
            defineAndManageCustomDataFields: "Define and manage custom data fields for the loan application.",
            addDataField: "ADD DATA FIELD",
            dataField: "Data Field",
            type: "Type",
            subdata: "Subdata",
            mandatory: "Mandatory",
            group: "Group",
            yes: "Yes",
            no: "No",
            noDataFieldsYet: "No data fields added yet. Click ADD DATA FIELD to create one.",
            textField: "Text Field",
            textArea: "Text Area",
            textFieldNumeric: "Text Field Numeric",
            radioButton: "Radio Button",
            checkBoxes: "Check Boxes",
            dropdown: "Dropdown",
            measurementUnit: "Measurement Unit",
            attachFile: "Attach File",
            digitalSignatureLabel: "Digital Signature",
            dataList: "Data List",
            date: "Date",
            selectDataType: "Select data type",
            fieldTitle: "Field Title",
            groupTitle: "Group Title",
            enterGroupTitle: "Enter group title",
            allowMultipleInputs: "Allow Multiple Inputs",
            allowedFileTypes: "Allowed File Types",
            imageJpegGifPng: "Image (JPEG, GIF, PNG)",
            videoMp4: "Video (MP4)",
            docx: "DOCX",
            options: "Options",
            typeHere: "Type Here",
            unitType: "Unit Type",
            selectUnitType: "Select unit type",
            selectType: "Select type",
            allowUserToChangeUnitType: "Allow User to Change Unit Type",
            help: "Help",
            writeHelpTextUsers: "Write a help text for the users.",
            helpText: "Help Text",
            addHelpTextForThisDataField: "Add help text for this data field",
            addFieldToGroup: "Add Field to Group",
            cancelUpper: "CANCEL",
            submitUpper: "SUBMIT",
            groupTitleRequired: "Group title is required",
            atLeastOneFieldRequiredInGroup: "At least one field is required in a group",
            fieldTitleRequiredForAllGroupFields: "Field title is required for all group fields",
            atLeastOneOptionRequiredFor: "At least one option is required for",
            atLeastOneFileTypeMustBeSelected: "At least one file type must be selected",
            fieldTitleRequired: "Field title is required",
            atLeastOneOptionRequired: "At least one option is required",
        },
        loanApplications: {
            activityDescription: "Activity Description",
            activityLog: "Activity Log",
            addAnyInternalNotesOrReviewCommentsAboutThisLoanApplication: "Add any internal notes or review comments about this loan application.",
            additionalInformationRequested: "Additional Information Requested",
            additionalLoanRelatedQuestionsAndSupportingDocuments: "Additional loan-related questions and supporting documents.",
            additionalQuestions: "Additional Questions",
            address: "Address",
            amount: "Amount",
            applicantDetails: "Applicant Details",
            applicationHasBeenSentToTheBankForApproval: "Application has been sent to the bank for approval.",
            applicationId: "Application ID",
            applicationIdAndSubmissionDate: "Application ID & Submission Date",
            apply: "Apply",
            approvalProcess: "Approval Process",
            approvalProcessHasBeenStartedYouCanNowFillFinalizeContractAndLoanDetails: "Approval process has been started. You can now fill Finalize Contract and Loan Details.",
            approve: "Approve",
            approved: "Approved",
            areYouSureYouWantToApproveTheLoanApplication: "Are you sure you want to approve the loan application?",
            areYouSureYouWantToRejectTheLoanApplication: "Are you sure you want to reject the loan application?",
            areYouSureYouWantToSendTheApplicationToTheBankForApprovalProcess: "Are you sure you want to send the application to the bank for approval process.",
            areYouSureYouWantToStartTheApprovalProcess: "Are you sure you want to start the approval process?",
            area: "Area",
            areaHa: "Area (ha)",
            attachContractOptional: "Attach Contract (optional)",
            attachment: "Attachment",
            back: "Back",
            cancel: "Cancel",
            circular: "Circular",
            close: "Close",
            closeUpper: "CLOSE",
            confirm: "Confirm",
            confirmation: "Confirmation",
            contract: "Contract",
            couldNotLoadLoanApplication: "Could not load loan application.",
            couldNotSendRequest: "Could not send request.",
            couldNotUpdateApplication: "Could not update application.",
            country: "Country",
            customization: "Customization",
            date: "Date",
            dateAndTime: "Date & Time",
            describeHere: "Describe here",
            description: "Description",
            digitallySigned: "Digitally Signed",
            disclaimerTitle: "Disclaimer",
            disbursedAmount: "Disbursed Amount",
            disbursementScheduleFromBankToFarmer: "Disbursement schedule from bank to farmer.",
            doYouWantUsToCollectTheContractSignature: "Do you want us to collect the contract signature?",
            doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Do you want us to collect the contract signature? If yes, attach the contract (optional) and we will send it to the farmer to sign in the app. If no, the contract is already signed or will be signed offline. After you attach and save, the contract will be sent to the farmer to sign; you'll receive a notification once it's signed.",
            download: "Download",
            dueDate: "Due Date",
            email: "Email",
            enterHere: "Enter here",
            error: "Error",
            farm: "Farm",
            farmDetails: "Farm Details",
            farmReports: "Farm Reports",
            farmer: "Farmer",
            farmerResponse: "Farmer Response",
            farmerUpdates: "Farmer Updates",
            farmReportsSoilDisclaimer: "The information on this section is provided for general reference only. It should not replace professional soil lab analysis. Use this information only if other soil analysis options are unavailable. Always consult agricultural experts before making decisions.",
            farmReportsYieldBullet1: "It is impossible to accurately predict the weather for a whole season, so in some cases farmers could lose all their harvest due to just one hail event or flooding (especially now that global warming is often causing all these irregularities).",
            farmReportsYieldBullet2: "Yields are highly dependent on the management practices of farmers. For example, if they fail to spray pesticides at the right time, or irrigate properly, then yields will be very different from the predictions - this is also beyond our control.",
            farmReportsYieldBullet3: "There are many other factors like the above that may contribute to significant errors in the AI yield predictions.",
            farmReportsYieldBullet4: "If the farmer provides historical yields (ADVANCED mode), then predictions tend to be more accurate than the default (non-ADVANCED mode) predictions.",
            farmReportsYieldUncertaintyIntro: "In our yield predictions, the uncertainty may be 100% because there are many factors that are beyond our control, including:",
            forecastedYields: "Forecasted Yields",
            graph: "Graph",
            yieldsKgAxis: "Yields (kg)",
            yieldForecasts: "Yield Forecasts",
            farmerUploadedAttachmentS: "Farmer uploaded attachment(s).",
            finalizeContract: "Finalize Contract",
            financeManagement: "Finance Management",
            firstName: "First Name",
            generatePaymentSchedule: "GENERATE PAYMENT SCHEDULE",
            geolocation: "Geolocation",
            gracePeriod: "Grace Period",
            gracePeriodType: "Grace Period Type",
            historyOfActionsTakenOnThisLoanApplication: "History of actions taken on this loan application.",
            ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline: "If you want us to collect the applicant's signature, choose Yes and attach the contract. After you save, it will be sent to the farmer to sign in the app; you'll receive a notification once signed. Contract upload is optional—e.g. if the contract is already signed or will be signed offline.",
            information: "Information",
            informationRequestedFromBank: "Information Requested from Bank",
            installment: "Installment",
            installmentDetails: "Installment Details",
            interestRate: "Interest Rate",
            ipAddress: "IP Address",
            keySoilNutrientLevelsForTheFarm: "Key soil nutrient levels for the farm.",
            landSuitabilityReport: "Land Suitability Report",
            lastName: "Last Name",
            loadingData: "Loading Data...",
            loanAmount: "Loan Amount",
            loanApplicationDetails: "Loan Application Details",
            loanApplicationHasBeenApproved: "Loan application has been approved.",
            loanApplicationHasBeenRejected: "Loan application has been rejected.",
            loanApplications: "Loan Applications",
            loanDetails: "Loan Details",
            loanDetailsSummary: "Loan details summary.",
            loanDisbursementBankFarmer: "Loan Disbursement (Bank -> Farmer)",
            loanDisbursementPlan: "Loan Disbursement Plan",
            loanProgram: "Loan Program",
            loanPrograms: "Loan Programs",
            loanRepaymentFarmerBank: "Loan Repayment (Farmer -> Bank)",
            loanRepaymentPlan: "Loan Repayment Plan",
            missingApplicationId: "Missing application id.",
            moderate: "Moderate",
            notApplicable: "N/A",
            nitrogenContent: "Nitrogen Content",
            noAdditionalQuestions: "No additional questions.",
            noContractIsAlreadySignedOrWillBeSignedOffline: "No — contract is already signed or will be signed offline",
            noMapCoordinatesForThisFarm: "No map coordinates for this farm.",
            notes: "Notes",
            numberOfDisbursements: "Number of Disbursements",
            numberOfInstallments: "Number of Installments",
            of: "of",
            openFile: "Open file",
            orDragAndDropHere: "or drag and drop here",
            overallLandSuitabilityScoreAndCategory: "Overall land suitability score and category.",
            overallScoreForLandSuitability: "Overall Score For Land Suitability",
            paid: "Paid",
            paymentDetails: "Payment Details",
            payments: "Payments",
            pending: "Pending",
            phoneNumber: "Phone Number",
            phosphorusContent: "Phosphorus Content",
            pleaseEnterAValidInterestRateToGenerateRepaymentPlan: "Please enter a valid Interest Rate to generate repayment plan.",
            pleaseEnterAValidLoanAmountToGenerateDisbursementPlan: "Please enter a valid Loan Amount to generate disbursement plan.",
            pleaseEnterAValidLoanAmountToGenerateRepaymentPlan: "Please enter a valid Loan Amount to generate repayment plan.",
            pleaseEnterNumberOfInstallmentsToGenerateRepaymentPlan: "Please enter Number of Installments to generate repayment plan.",
            pleaseEnterYourCommentsOrInstructions: "Please enter your comments or instructions.",
            pleaseProvideSpecificCommentsOrInstructionsInTheTextBoxBelowOnceSubmittedTheFarmerWillBeNotifiedYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Please provide specific comments or instructions in the text box below. Once submitted, the farmer will be notified. You will be notified when the farmer updates the application.",
            polygon: "Polygon",
            potassiumContent: "Potassium Content",
            principalAndInterest: "Principal & Interest",
            print: "Print",
            projectedYieldComparisonByYear: "Projected yield comparison by year.",
            provinceState: "Province / State",
            question: "Question",
            recordsPerPage: "Records per Page",
            regionDistrict: "Region / District",
            reject: "Reject",
            rejected: "Rejected",
            repaymentScheduleFromFarmerToBank: "Repayment schedule from farmer to bank.",
            requestAdditionalInformation: "Request Additional Information",
            restoreDefault: "Restore Default",
            search: "Search",
            select: "Select",
            selectFileToUploadTheContract: "Select file to Upload the Contract",
            selectNoIfYouHaveAlreadySignedTheContractWithTheApplicantFarmerSelectYesIfYouWantTheApplicantFarmerToSignTheLoanContractOnHisDimitraMobileApp: "Select No, if you have already signed the contract with the applicant (farmer). Select YES, if you want the applicant (farmer) to sign the loan contract on his Dimitra Mobile App?",
            send: "Send",
            sendToBank: "Send To Bank",
            sentToBank: "Sent to Bank",
            signedOffline: "Signed offline",
            soilAnalysisReport: "Soil Analysis Report",
            someDisclaimerOrShortExplainerAboutFollowingReports: "Some disclaimer or short explainer about following reports.",
            srd: "SRD",
            startDate: "Start Date",
            status: "Status",
            statusLegend: "Status Legend",
            submissionDate: "Submission Date",
            success: "Success",
            tapTheMapToExpandIt: "Tap the map to expand it.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponses: "This section shows additional information requests sent to the farmer and their responses.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponsesYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "This section shows additional information requests sent to the farmer and their responses. You will be notified when the farmer updates the application.",
            totalInstallments: "Total Installments",
            totalInterestApprox: "Total Interest (Approx)",
            totalLoanAmount: "Total Loan Amount",
            totalPayment: "Total Payment",
            totalRepayment: "Total Repayment",
            transactionIdAndDate: "Transaction ID & Date",
            typeYourLocationNameAddress: "Type your location name/address",
            upcoming: "Upcoming",
            uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Upload the unsigned contract. After you attach and save, it will be sent to the farmer to sign. You'll receive a notification once it's signed.",
            user: "User",
            userDetails: "User Details",
            userRole: "User Role",
            validation: "Validation",
            viewFullReport: "View full report",
            viewGeolocation: "View Geolocation",
            villageTownCity: "Village / Town / City",
            waitingSignatures: "Waiting Signatures",
            warning: "Warning",
            year2025: "2025",
            year2026: "2026",
            yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp: "Yes — attach the contract and we'll send it to the farmer to sign in the app",
            yieldPredictionReport: "Yield Prediction Report",
            youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline: "You may upload the signed contract for your records, or leave empty if the contract is private or signed offline.",
            yourRequestHasBeenSentTheFarmerWillBeNotified: "Your request has been sent. The farmer will be notified.",
            yieldForecastChartAria: "Yield forecast chart",
            yearsAxisLabel: "Years",
            soilAnalysisSectionTitle: "Soil Analysis",
            soilMetricNitrogenN: "Nitrogen (N)",
            soilMetricPhosphorusP: "Phosphorus (P2O5)",
            soilMetricPotassiumK: "Potassium (K2O)",
            soilAnalysisPlaceholderTitle: "What this means (placeholder)",
            soilAnalysisPlaceholderBody: "This page shows a simplified soil nutrient summary. Once the backend data source is integrated, this section can be expanded into full soil profile charts and recommendations.",
            landSuitabilitySectionTitle: "Land Suitability",
            overallSuitabilityScoreLabel: "Overall Suitability Score",
            suitabilityFactorsPlaceholder: "Suitability factors (placeholder)",
            factorSoilQuality: "Soil quality",
            factorClimateFit: "Climate fit",
            factorWaterAvailability: "Water availability",
            factorRiskFactors: "Risk factors",
            landSuitabilityExpertFooter: "AI can make mistakes, please double check with local agronomy experts before decisions.",
        },

        banks: {
            title: 'Banks',
            addNewBank: 'Add New Bank',
            bankDetails: 'Bank Details',
            bank: 'Bank',
            bankTitle: 'Bank Title',
            attachBankLogo: 'Attach Bank Logo',
            addImage: 'Add Image',
            contactDetails: 'Contact Details',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            phone: 'Phone Number',
            enterHere: 'Enter here',
            apiIntegrationInfo: 'API Integration Info',
            apiBaseUrl: 'API Base URL',
            clientId: 'Client ID / Public Key',
            clientSecret: 'Client Secret / Private Key',
            accountAdminCredentials: 'Account/Admin Credentials',
            adminUsername: 'Admin Username',
            password: 'Password',
            require2FA: 'Require 2FA',
            enable: 'Enable',
            copy: 'Copy',
            regenerate: 'Regenerate',
            edit: 'Edit',
            back: 'Back',
            cancel: 'Cancel',
            save: 'Save',
            firstNameInfo: 'First Name Info',
            lastNameInfo: 'Last Name Info',
            emailInfo: 'Email Info',
            phoneInfo: 'Phone Number Info',
            apiBaseUrlInfo: 'API Base URL Info',
            clientIdInfo: 'Client ID Info',
            clientSecretInfo: 'Client Secret Info',
            adminUsernameInfo: 'Admin Username Info',
            passwordInfo: 'Password Info',
            contactPerson: 'Contact Person',
            management: 'Finance Management',
            editBank: 'Edit Bank',
            changeImage: 'Change Image',
            failedToLoadBankDetails: 'Failed to load bank details',
            bankUpdatedSuccessfully: 'Bank updated successfully',
            bankCreatedSuccessfully: 'Bank created successfully',
            errorUpdatingBank: 'Error updating bank',
            errorCreatingBank: 'Error creating bank',
            bankLogo: 'Bank Logo',
            bankLogoPreview: 'Bank Logo Preview',
            notAvailable: 'N/A',
        },
        dashboard: {
            title: "Finance Dashboard",
            avgLoanAmount: "Average Loan Amount",
            vsLastMonth: "vs Last Month",
            totalApplications: "Total Applications",
            approvalRate: "Approval Rate",
            loanApplicationsChart: "Loan Applications",
            applicationsByStatus: "Applications by Status",
            applicationsByRegion: "Applications by Region",
            regionBreakdown: "Region Breakdown",
            averageLoanAmountTrend: "Average Loan Amount Trend",
            loanAmountOverTime: "Loan Amount Over Time",
            avgAmount: "Average Amount"
        },
        status: {
            approved: "Approved",
            pending: "Pending",
            waiting: "Waiting",
            rejected: "Rejected"
        },
        reports: {
            today: "Today",
            week: "Week",
            month: "Month",
            year: "Year"
        },
    },
}
